import React, { useRef, useState } from 'react'
import ReCaptchaV2 from 'react-google-recaptcha';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { IoClose } from "react-icons/io5";
import { Button } from '../../Atoms';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';




const FullScreenLoader = () => {
  return (
    <section className="fixed z-[1000] top-0 left-0 right-0 bottom-0 bg-black bg-opacity-30 grid place-content-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="120px"
        height="120px"
        className="h-24 w-24 "
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
      >
        <circle
          cx="50"
          cy="50"
          fill="none"
          stroke="#24B354"
          strokeWidth="10"
          r="35"
          strokeDasharray="164.93361431346415 56.97787143782138"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            repeatCount="indefinite"
            dur="1s"
            values="0 50 50;360 50 50"
            keyTimes="0;1"
          ></animateTransform>
        </circle>
      </svg>
    </section>
  );
};

function FormModal({ isModalOpen, productTitle, setIsModalOpen }) {
  const [errors, setErrors] = useState({});
  const [captchaToken, setCaptchaToken] = useState(null);
  const captchaRef = useRef(null);
  const [isLoading, setLoading] = useState(false);
  const RECAPTCHA_SITE_KEY = process.env.REACT_APP_CAPTCHA_KEY ?? '';
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    product: productTitle || '',
  });


  // Handle form input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCaptchaChange = (token) => setCaptchaToken(token);

  const handleCaptchaExpire = () => {
    setCaptchaToken(null);
    setTimeout(() => {
      if (captchaRef.current) {
        captchaRef.current.reset();
      }
    }, 500);
  };

  const validateForm = () => {
    let errors = {};
    if (!formData.name.trim()) errors.name = "Name is required";
    if (!formData.email.trim()) {
      errors.email = "Email is required";
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      errors.email = "Invalid email format";
    }
    if (!formData.phone.trim()) {
      errors.phone = "Phone is required";
    } else if (!/^\d{8,15}$/.test(formData.phone)) {
      errors.phone = "Invalid Phone Number";
    }
    if (!formData.message.trim()) errors.message = "Message is required";

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();


    console.log("Validating form...");
    if (!validateForm()) {
      console.log("Form validation failed!");
      return;
    }

    console.log("Form validation passed!");

    const requestData = {
      fullName: formData.name,
      emailAddress: formData.email,
      productName: formData.product,
      phoneNumber: formData.phone,
      message: formData.message,
      companyName: ""
    };
    setLoading(true)
    try {
      const endpoint = 'https://mailservice.verdemobility.com/api/Email/product-form';

      const response = await axios.post(endpoint, requestData);

      console.log("API Response:", response);

      if (response.status === 200 || response.status === 201) {
        toast.success('User form submitted successfully!');

        setTimeout(() => {
          closeModal();
          resetForm(); // Reset after closing modal
        }, 1200);
      } else {
        toast.error('Unexpected response. Please try again.');
      }

    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error('Failed to submit request. Try again later.');
    } finally {
      setLoading(false);
    }
  };


  const resetForm = () => {
    setFormData({
      name: "",
      email: "",
      phone: "",
      message: "",
    });
    setErrors({}); // Clear errors
  };
  const closeModal = () => {
    setIsModalOpen(false)
    resetForm();
    setCaptchaToken(null);
  };
  // if (!isModalOpen) return null;
  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-[999]">
      {isLoading ? <FullScreenLoader /> : ''}
      <div className="bg-white p-6 rounded shadow-lg max-w-md w-full">
        <div className='flex justify-between items-center mb-3'>
          <h2 className="text-xl">Form</h2>
          <IoClose className='text-lg cursor-pointer' onClick={closeModal} />
        </div>
        <div>
          <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Name Field */}
            <div>
              <label className="block text-gray-700">Full Name*</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-500 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}
            </div>

            {/* Email Field */}
            <div>
              <label className="block text-gray-700">Email Address*</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-500 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
            </div>

            {/* Phone Field */}
            <div>
              <label className="block text-gray-700">Phone Number*</label>              
              <PhoneInput
                country={'in'}
                value={formData.phone}                
                onChange={(value, country) => {  
                  setFormData({
                    ...formData,
                    phone: value,
                    dialCode: country?.dialCode || '',                    
                  });
                }}
                inputProps={{
                  name: 'phone',
                  required: true,
                }}
                
                containerClass="w-full"
                inputClass="!w-full !px-3 !h-[40px] !pl-11 !pr-2 !border !border-gray-500 !rounded-lg !focus:outline-none !focus:ring-2 !focus:ring-blue-500"
              />

              {/* <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-500 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              /> */}
              {errors.phone && <p className="text-red-500 text-sm">{errors.phone}</p>}
            </div>

            {/* Product Field */}
            <div>
              <label className="block text-gray-700">Product Name*</label>
              <input
                type="text"
                name="product"
                value={formData.product}
                onChange={handleChange}
                disabled
                className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* Message Field (Full Width) */}
            <div className="md:col-span-2">
              <label className="block text-gray-700">Message*</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded-lg border-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              {errors.message && <p className="text-red-500 text-sm">{errors.message}</p>}
            </div>

            <div>
              <ReCaptchaV2
                sitekey={RECAPTCHA_SITE_KEY}
                ref={captchaRef}
                onChange={handleCaptchaChange}
                onExpired={handleCaptchaExpire}
              />
            </div>

            {/* Submit & Close Buttons */}
            <div className="md:col-span-2 flex justify-between mt-4">
              <button
                type="submit"
                disabled={!captchaToken}
              >
                <Button title="Send" isDisabled={!captchaToken} />
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default FormModal